import { UrlMatchResult, UrlSegment } from '@angular/router';
import { ENTITY_MODE } from '../../../shared/typings/types/entity-mode.types';

// Match on entity id first path
export function entityIdFirstMatcher (segments: UrlSegment[]): UrlMatchResult | null {
  if (!segments.length) return null;

  const [firstSegment] = segments;
  const firstPath = firstSegment.path;

  if (firstPath === ENTITY_MODE.SINGLE_ENTITY_URL_PREFIX || firstPath === ENTITY_MODE.MULTI_ENTITY_URL_PREFIX) return null;

  return { consumed: segments, posParams: { entityId: firstSegment } };
}
